import React, { Component } from 'react';
import { motion, AnimatePresence } from "framer-motion";
import i18n from "../../../i18n";

const viewportWidth = window.innerWidth;
const viewportHeight = window.innerHeight;

const EMOTIONS = [
  { key: 'Like', label: i18n.t('Like'), icon: '/img/em_blove.png' },
  { key: 'Inspiring', label: i18n.t('Inspiring'), icon: '/img/em_inspiring.png' },
  { key: 'Sad', label: i18n.t('Sad'), icon: '/img/em_bface.png' },
  { key: 'Angry', label: i18n.t('Angry'), icon: '/img/em_angry.png' },
  { key: 'Happy', label: i18n.t('Happy'), icon: '/img/em_bjoy.png' },
  //{ key: 'curiosite', label: 'Curiosité', icon: '/img/em_inspiration.png' },
  { key: 'Thoughtful', label: i18n.t('Thoughtful'), icon: '/img/em_bthinking.png' },
  { key: 'Connected', label: i18n.t('Connected'), icon: '/img/em_connexion.png' }
];

export default class EmotionReactionsMobile extends Component {
  constructor(props) {
    super(props);

    let em = null;
    if (props.user !== null && props.item.reactions.some(obj => obj.uid === props.user.uid))
    {
       em = props.item.reactions.find(obj => obj.uid === props.user.uid).emotion.emotion;
       if (em !== undefined && em !== null)
       {
         em.label = i18n.t(em.key);
       }
      
     }


    this.state = {
      showReactions: false,
      selectedEmotion: em, // {"key":"love","label":"J'aime","icon":"/img/em_blove.png"}, //null,
      reactionCounts: {
        inspiration: 0,
        tristesse: 0,
        colere: 0,
        joie: 0,
        curiosite: 0,
        reflexion: 0,
        connexion: 0
      }
    };
  }

  handleEmotionClick = (emotion) => {
    if (this.props.user === null)
    {
         if (this.props.onReact) {
            this.props.onReact(null);
         }
    }
    else
    {
          const { selectedEmotion, reactionCounts } = this.state;
          const newCounts = { ...reactionCounts };

          if (selectedEmotion?.key === emotion.key) {
            // toggle off
            newCounts[emotion.key] = Math.max(0, newCounts[emotion.key] - 1);
            this.setState({ selectedEmotion: null, showReactions: false, reactionCounts: newCounts });
          } else {
            // toggle on
            if (selectedEmotion) {
              newCounts[selectedEmotion.key] = Math.max(0, newCounts[selectedEmotion.key] - 1);
            }
            newCounts[emotion.key] = (newCounts[emotion.key] || 0) + 1;
            //alert(JSON.stringify(emotion))
            this.setState({ selectedEmotion: emotion, showReactions: false, reactionCounts: newCounts });
          }

          if (this.props.onReact) {
            this.props.onReact(emotion);
          }

     }
  };

  render() {
    const { showReactions, selectedEmotion, reactionCounts } = this.state;

    return (
      <div
        className="reaction-container"
        onMouseEnter={() => this.setState({ showReactions: true })}
        onMouseLeave={() => this.setState({ showReactions: false })}
      >
        <button className={selectedEmotion ? 'react-button-selected':'react-button'} style={{color: selectedEmotion ? '#0b49ff':'#111'}}>
          {selectedEmotion ? (
            <>
              <img src={selectedEmotion.icon} alt={selectedEmotion.label} className="button-icon" />
            </>
          ) : (
            <>
             <img src={'/img/em_react.png'} alt={i18n.t('React')} className="button-icon" />
               {i18n.t('React')}
             </>
           )}
        </button>
        <AnimatePresence>
        {showReactions && (
          <motion.div className="reaction-popover-mobile"
          initial={{ opacity: 0, y: 10, scale: 0.5 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 10, scale: 0.5 }}
          transition={{ type: "spring", stiffness: 300, damping: 20 }}>
            {EMOTIONS.map((emotion) => (
              <div
                key={emotion.key}
                onClick={() => this.handleEmotionClick(emotion)}
                className={`reaction-item ${selectedEmotion?.key === emotion.key ? 'active' : ''}`}
              >
                <img src={emotion.icon} alt={emotion.label} className="reaction-icon" style={{width: ((viewportWidth/7)-16)+'px', height: ((viewportWidth/7)-16)+'px'}} />
                <div className="tooltip">{emotion.label}</div>
                <div className="counter" style={{display: 'none'}}>{reactionCounts[emotion.key]}</div>
              </div>
            ))}
          </motion.div>
        )}
        </AnimatePresence>
      </div>
    );
  }
}
